import React from 'react'
import { ScaleLoader } from 'react-spinners';

function Spinner({ loading }) {
    return (
        <span>
            {
                loading &&
                <div className="spinnerDiv">
                    <ScaleLoader
                        className="spinner"
                        sizeUnit={"px"}
                        size={20}
                        color={'#87CEFA'}
                        loading={loading}
                    />
                </div>
            }
        </span>
    )
}

export default Spinner
